(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("cheetah-grid"));
	else if(typeof define === 'function' && define.amd)
		define(["vue", "cheetah-grid"], factory);
	else if(typeof exports === 'object')
		exports["vueCheetahGrid"] = factory(require("vue"), require("cheetah-grid"));
	else
		root["vueCheetahGrid"] = factory(root["Vue"], root["cheetahGrid"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__6__) {
return 